import _ from "lodash";
import logger from "../../utils/LoggerFrontend";
import React from "react";
import { NavLink } from "react-router-dom";
const classNames = require("classnames");
import moment from "moment";

import { t } from "i18next";

import { renderStatus } from "../../utils/Helpers";
import { Trans } from "react-i18next";

export default class CampaignLeftSideBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSidePanel: false,
      isFilterMenuOpen: false,
      searchTerm: "",
      campaigns: undefined
    };
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        showSidePanel: true
      });
    }, 300);
  }
  toggleFilter(e) {
    this.setState({
      isFilterMenuOpen: !this.state.isFilterMenuOpen
    });
  }
  renderFilter() {
    return null;
  }
  search(e) {
    var search = (e.target.value || "").toLowerCase();

    var sortedArray = _.filter(this.props.campaigns, function (el) {
      if (el.status === "IN_PROGRESS" || el.status === "ACTIVE") {
        return true;
      }
      return false;
    }).filter((el) => {
      if (
        el.companyName.toLowerCase().indexOf(search) > -1 ||
        el.jobTitle.toLowerCase().indexOf(search) > -1
      ) {
        return true;
      }
      return false;
    });

    this.setState({
      searchTerm: e.target.value,
      campaigns: sortedArray
    });
  }
  renderCampaigns(campaigns) {
    var adminPrefix = this.props.isAdmin ? "admin-" : "";

    return campaigns.map((campaign, campaignId) => {
      var date = moment(campaign.created).fromNow();

      return (
        <li className="campaign-read__list-item" key={"li-" + campaignId}>
          <NavLink
            activeClassName="campaign-read__list-link--active"
            to={`/${adminPrefix}campaign/${campaign.organizationId}/${campaign.id}`}
          >
            <span
              className={`campaignlist__company__state campaign-read__state--${campaign.status}`}
            >
              {renderStatus(campaign.status, t)}
            </span>
            <strong className="campaignlist__job">{campaign.campaignName}</strong>
            <span className="campaignlist__company">{campaign.companyName}</span>
          </NavLink>
        </li>
      );
    });
  }
  renderFallback() {
    return (
      <div className="campaign-read__empty-search">
        <Trans
          i18nKey="No campaigns found with the search term <strong>{{searchTerm}}</strong>."
          values={{ searchTerm: this.state.searchTerm }}
          components={{ strong: <strong /> }}
        />
      </div>
    );
  }
  render() {
    var campaigns = this.state.campaigns || this.props.campaigns;

    var view;
    if (campaigns.length === 0) {
      view = this.renderFallback();
    } else {
      view = this.renderCampaigns(campaigns);
    }

    const styles = classNames({
      "campaign-read__list": true,
      "fade-in": true,
      "campaign-read__list--transition-left": !this.state.showSidePanel
    });

    logger.debug("CampaignLeftSidebar:render", "called", this.state.isFilterMenuOpen);

    const classSearch = classNames({
      "dashboard__search-close": true,
      "dashboard__search-close--close": this.state.searchTerm == ""
    });

    return (
      <div>
        <div className="campaign-read__filters">
          <div className="campaign-read__search">
            <input
              type="text"
              onChange={this.search.bind(this)}
              placeholder={t("Search")}
              value={this.state.searchTerm}
              className="campaign-read__search-field"
            />
            <div
              className={classSearch}
              onClick={() => {
                this.setState({ searchTerm: "", campaigns: undefined });
              }}
            >
              x
            </div>
          </div>

          {this.renderFilter()}
        </div>
        <div className={styles}>
          <ul>{view}</ul>
        </div>
      </div>
    );
  }
}
